import { SPEED_UNIT } from '@/common/constant';
import storage, { RangeLimit } from '@/renderer/scripts/utils/storage';
import { storageCache } from '@/renderer/scripts/utils/storage/StorageCache';

export class SystemSetting {
  // 获取传输设置相关配置
  public static getSystemTransferSetting(type: 'upload' | 'download'): RangeLimit {
    if (type === 'upload') {
      return storageCache.getCache<RangeLimit>(storage.StoreKey.UPLOAD_TRANSFER_SETTING);
    }
    return storageCache.getCache<RangeLimit>(storage.StoreKey.DOWNLOAD_TRANSFER_SETTING);
  }
  // 把传输的设置信息转换为KB单位
  public static convertTransferSpeed(speedLimitSize: number, speedLimitUnit: string): number {
    if (speedLimitUnit === SPEED_UNIT.mbs) return speedLimitSize * 1024;
    return speedLimitSize;
  }
}
